import { render, staticRenderFns } from "./KnowledgeContentPreview.vue?vue&type=template&id=6af6dbc6&"
import script from "./KnowledgeContentPreview.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports